import React, { useState, useEffect, useRef, useContext } from "react";
import { useOutletContext } from "react-router-dom";
import "./CustomerDetails.css";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import SearchField from "../SearchField/SearchField";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { gsap } from "gsap";
import SocketContext from "../../contexts/SocketContext";

const CustomerDetails = () => {
  // General States
  const axiosPrivate = useAxiosPrivate(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  //Refs
  const UCMRef = useRef(null);

  // Import Outlet Context Properties
  const [
    showCustDetails,
    selectedCustomer,
    setSelectedCustomer,
    setReloaddata,
    reloaddata,
    setShowsuccess,
    setSuccessMSG,
  ] = useOutletContext();

  // Customer Edits
  const [customerEdits, setCustomerEdits] = useState(selectedCustomer ? selectedCustomer : {});
  const [editingCustomer, setEditingCustomer] = useState(false);
  const [deletecheck, setDeletecheck] = useState();

  // Handle Input Change
  const handleInputChange = (e) => {
    setEditingCustomer(true);
    setCustomerEdits({ ...customerEdits, [e.target.name]: e.target.value });
  };

  // Handle Country Select
  const handleCountrySelect = (item) => {
    setCustomerEdits({ ...customerEdits, ["country"]: item.country, ["countryID"]: item.countryID });
    setEditingCustomer(true);
  };
  // Handle Port Select
  const handlePortSelect = (item) => {
    setCustomerEdits({ ...customerEdits, ["portOfDestination"]: item.portOfDestination, ["PODID"]: item.PODID });
    setEditingCustomer(true);
  };

  // Set selected customer on change of selected customer
  useEffect(() => {
    setCustomerEdits(selectedCustomer);
    setEditingCustomer(false);
    setToggleClearSF(!toggleClearSF);
  }, [selectedCustomer]);

  // Save customer edits
  const saveCustomerEdits = async () => {
    try {
      const response = await axiosPrivate.post("api/customers/updatecustomer", {
        customerEdits,
      });
      if (response.data.msg === "Saved") {
        let customerEditsSocket = { ...customerEdits, ["region"]: response.data.region };
        setReloaddata(!reloaddata);
        setShowsuccess((prev) => !prev);
        setSuccessMSG("Edits saved successfully.");
        setEditingCustomer(false);
        await socket.emit("updatecustomer", customerEditsSocket);
      }
      if (response.data.msg !== "Saved") {
        setShowsuccess((prev) => !prev);
        setSuccessMSG("Edits saved successfully.");
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // Delete Customer
  const deleteCustomer = async (custID) => {
    const response = await axiosPrivate.post("api/customers/deletecustomer", { custID });
    if (response.data.msg === "Deleted") {
      setDeletecheck("");
      setReloaddata(!reloaddata);
      setSelectedCustomer("");
      await socket.emit("deletecustomer", selectedCustomer.customerID);
    }
    if (response.data.msg === "Not Found") {
      setDeletecheck("");
      setReloaddata(!reloaddata);
      setSelectedCustomer("");
    }
  };

  // Cleanup
  const [toggleClearSF, setToggleClearSF] = useState(false);

  return (
    <div className='custDetails'>
      {showCustDetails && (
        <>
          <h1>{selectedCustomer.companyCode}</h1>
          <h2>Edit Customer:</h2>
          <form
            className='editcustomer'
            onSubmit={(e) => {
              e.preventDefault();
              saveCustomerEdits();
            }}
          >
            <div className='form-item'>
              <label>Customer ID:</label>
              <input readOnly style={{ background: "var(--gray)" }} value={customerEdits?.customerID} />
            </div>
            <div className='form-item'>
              <label>Company Code:</label>
              <input
                required
                name='companyCode'
                autoComplete='off'
                onChange={(e) => handleInputChange(e)}
                value={customerEdits?.companyCode}
              />
            </div>
            <div className='form-item'>
              <label>Company Name:</label>
              <input
                required
                name='companyName'
                autoComplete='off'
                onChange={(e) => handleInputChange(e)}
                value={customerEdits?.companyName}
              />
            </div>
            <div className='form-item'>
              <label>Address:</label>
              <textarea
                required
                name='streetAddress'
                autoComplete='none'
                onChange={(e) => handleInputChange(e)}
                value={customerEdits?.streetAddress}
              />
            </div>
            <div className='form-item'>
              <label>City:</label>
              <input
                required
                name='city'
                autoComplete='none'
                onChange={(e) => handleInputChange(e)}
                value={customerEdits?.city}
              />
            </div>
            <div className='form-item'>
              <label>Country:</label>
              <SearchField
                required={true}
                searchURL='api/countries/getcountries'
                value={customerEdits.country}
                valueName='country'
                valueID='countryID'
                style={{ width: "95%" }}
                onItemSelect={handleCountrySelect}
                clearfield={toggleClearSF}
              />
            </div>
            <div className='form-item'>
              <label>Default POD:</label>
              <SearchField
                required={true}
                searchURL='api/ports/getalldisports'
                value={customerEdits.portOfDestination}
                valueName='portOfDestination'
                valueID='PODID'
                style={{ width: "95%" }}
                onItemSelect={handlePortSelect}
                clearfield={toggleClearSF}
              />
            </div>
            <div className='form-item'>
              <label>Website:</label>
              <input
                required
                name='website'
                autoComplete='none'
                onChange={(e) => handleInputChange(e)}
                value={customerEdits?.website}
              />
            </div>
            <div className='form-item'>
              <label>Notes:</label>
              <textarea
                name='notes'
                autoComplete='none'
                onChange={(e) => handleInputChange(e)}
                value={customerEdits?.notes}
              />
            </div>
            <div className='form-buttons'>
              <button
                type='button'
                onClick={(e) => {
                  navigate("/admin/customers", { state: { from: location }, replace: true });
                  setSelectedCustomer({});
                  setToggleClearSF(!toggleClearSF);
                }}
              >
                Cancel
              </button>
              <button
                type='submit'
                className={editingCustomer ? "mainbutton" : "disabledbutton"}
                disabled={!editingCustomer}
              >
                Save Edits
              </button>
            </div>
          </form>
          <h2>Delete Customer:</h2>
          <p>
            Type <b>{selectedCustomer.companyCode} : </b>
            <input
              autoComplete='off'
              name='deletecheck'
              value={deletecheck}
              style={{ marginRight: "1rem" }}
              onChange={(e) => {
                setDeletecheck(e.target.value);
              }}
            />
            {deletecheck == selectedCustomer.companyCode ? (
              <button style={{ margin: 0 }} onClick={(e) => deleteCustomer(selectedCustomer.customerID)}>
                Delete
              </button>
            ) : (
              ""
            )}
          </p>
        </>
      )}
    </div>
  );
};

export default CustomerDetails;
